<template>
  <div>
    <div class="cover cover--small" :style="'background-image: url(' + require('@/assets/cover-contact.jpg') + ')'"></div>
    <div class="white-box wrapper wrapper--spaced wrapper--centered">

      <template v-if="hasJoined">
        <div class="wrapper">
            <h1 class="title title--main">Thank you for pledging your vote!</h1>
            <p class="text">We'll be sure to keep you up to date on any key developments along the way and, of course, once Aaron makes a final decision on whether or not to run, you'll be the first to know.</p>        
            <p class="text">Together we can turn this province around! </p>            
            <p class="text">- Team Aaron</p>
        </div>
      </template>
      <template v-else>

        <template v-if="leadershipObject && leadershipObject.id">
          <h1 class="title title--main">{{ leadershipObject.name }}'s Pledged Votes for Aaron Gunn</h1>
          <p class="text text--bold">Welcome {{ leadershipObject.name }} and thank you for your continued hard work and dedication in helping Aaron Gunn bring common sense back to British Columbia.</p>
          <p class="text">To date, you have signed up <span style="color: red; font-weight: bold">{{ leadershipObject.count || 0 }}</span> new pledged voters to the movement. <span v-if="leadershipObject.rank && leadershipObject.rank > 0"> This makes you the <span style="color: red; font-weight: bold">{{ leadershipObject.rank }}th</span> most successful riding captain or regional coordinator in the province.</span></p>
          <p class="text">Add the names below of any British Columbians who you know have agreed to purchase a BC Liberal Party membership ($10) and vote for Aaron this February.</p>
        </template>
        <template v-else>
          <h1 class="title title--main">Pledge Your Vote to Turn British Columbia Around</h1>
          <iframe src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2FAaronGunn.ca%2Fvideos%2F229128302367901%2F&width=800&show_text=false&appId=372995680756245&height=500" width="800" height="500" style="border:none;overflow:hidden;margin-bottom:20px" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>
          <p class="text text--bold">On July 1st, 2021 Aaron announced his intention to explore a run to become the next leader of the right-leaning BC Liberal Party and, more importantly, the next Premier of British Columbia.</p>
          <p class="text">If you agree that it’s time for common-sense solutions and a leader that will stand up to the Radical Left (and Justin Trudeau), fill out the form below to pledge your vote, and let Aaron know that he can count on your support!</p>
        </template>
        <form method="post" action="https://aarongunn.ca/webservices/forms.php">
            <div class="form__item"><label>First Name*</label><input name="firstname" type="text" autocomplete="given-name" required/></div>
            <div class="form__item"><label>Last Name*</label><input name="lastname" type="text" autocomplete="family-name" required/></div>
            <div class="form__item"><label>Email*</label><input name="email" type="email" autocomplete="email" required/></div>
            <div class="form__item"><label>B.C. Postal Code*</label><input name="zip" type="text" autocomplete="postal-code" placeholder="V8V 1X4" pattern="[vV][0-9][A-Za-z][\s]?[0-9][A-Za-z][0-9]" required/></div>
            <div class="form__item"><label>Phone*</label><input name="phone" type="tel" autocomplete="tel" placeholder="123-456-7890" pattern="[1]?[-\s]?[(]?\d{3}[)\s]?[-\s]?\d{3}[-\s]?\d{4}" required/></div>
            
            <template v-if="leadershipObject && leadershipObject.id">
              <div class="form__item"><label>Referral*</label><select disabled><option value="">{{ leadershipObject.name }}</option></select></div>
              <div class="form__item"><label class="option" style="display: flex;"><input type="checkbox" name="join" value="yes"/> Did this individual agree to receive correspondence from the Aaron Gunn campaign?</label></div>
              <div class="form__item"><label class="option" style="display: flex;"><input type="checkbox" name="party_member" value="yes"/> Is this individual already a member of the BC Liberal Party?</label></div>
              <div class="form__item"><label class="option" style="display: flex;"><input type="checkbox" name="volunteer" value="yes"/> Is this individual interested in becoming a volunteer?</label></div>
              <div class="form__item"><label class="option" style="display: flex;"><input type="checkbox" name="contribution_interest" value="yes"/> Is this individual interested in contributing financially to the campaign?</label></div> 
            </template>
            <template v-else>
              <div class="form__item"><label class="option" style="display: flex;"><input type="checkbox" name="volunteer" value="yes"/> I’m interested in learning more about becoming a volunteer</label></div>
              <div class="form__item"><label class="option" style="display: flex;"><input type="checkbox" name="contribution_interest" value="yes"/> I’m interested in learning more about contributing financially</label></div> 
            </template>

            <input type="hidden" name="source" value="leadership"/>
            <template v-if="leadershipObject && leadershipObject.id">
              <input type="hidden" name="referral_id" :value="leadershipObject.id"/>
              <input type="hidden" name="referral_name" :value="leadershipObject.name"/>
            </template>              
            <input type="submit" value="Submit" class="button button--blue" style="margin:auto; display:block;"/>
        </form>
      </template>
    </div>
  </div>
</template>

<script>
import facebookMixin from '@/videos-mixin.js'
export default {
  created() {
    this.findMatchPattern().then(response => {
      this.leadershipObject = response;
    });
  },
  mixins: [facebookMixin],
  data () {
    return {
      leadershipObject: null
    }
  },
  computed: {
    hasJoined () {
      return this.$router.currentRoute.query.hasOwnProperty('added');
    },
    getVideoComputed () {
      return this.getFbVideo(229128302367901);
    }
  },
  methods: {
    findMatchPattern() {
      var httpRequest = new XMLHttpRequest();
      return new Promise(resolve => {
          httpRequest.onreadystatechange = () => {
              if (httpRequest.readyState !== 4) return;
              if (httpRequest.status >= 200 && httpRequest.status < 300) {
                  resolve(JSON.parse(httpRequest.response));
              }
          }
          httpRequest.open("POST", "https://aarongunn.ca/webservices/leadership.php", true);
          var formData = new FormData();
          formData.append("pattern", this.$route.params.volunter_pattern);
          httpRequest.send(formData);
      });
    }
  }
}
</script>

<style scoped>


</style>
